export const angularRouteViewComponent = {
  bindings: {
    reactAuth: '<',
    labelOverrideMap: '<',
    getAvailability: '<',
    getLabel: '<',
    getBoardName: '<',
    pusher: '<',
    openContactDrawer: '<',
    fetchOrgUsers: '<',
    setChatVisibility: '<',
    isMobileView: '<',
    orgStatus: '<',
    currentPlan: '<',
    favorites: '<',
    toggleFavorite: '<',
    openFeedbackModal: '<',
    openAppointmentActionModal: '<',
    isDoneWelcomeFlow: '<',
  },
  template: `
  <div ng-view ng-controller="DefaultController"></div>
  `,
};

export const externalAngularViewComponent = {
  bindings: {
    reactExternalAuth: '<',
    labelOverrideMap: '<',
    getAvailability: '<',
    getLabel: '<',
    getBoardName: '<',
    setAuth: '<',
  },
  template: `
    <div ng-view ng-controller="ExternalController"></div>
  `,
};
